/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Flex, Text, useDisclosure } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { FormButton } from '../../buttons/FormButton';
import { useFetch } from '../../../hooks/useFetch';
import AlertModal from '../../AlertModal';
import { PageTitle } from '../../PageTitle';
import { FormBox } from '../../formBox';
import { TextAreaInputForm } from '../../inputs/forms/TextAreaInputForm';
import { FormHeading } from '../../formHeading';

interface PoliticsFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: string;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function PoliticsForm({ defaultValues = {} }: PoliticsFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/globals';
  const { requestApi, error } = useFetch(baseUrl, { actionFeedback: false });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'privacy_policy',
      value: defaultValues.privacy_policy ?? '',
      placeholder: '',
      label: 'Descrição',
      yup: Yup.string(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const privacyPolicy = formInputs.find((field) => field.name === 'privacy_policy');

  const onSubmit = async (values: any) => {
    const params = {
      ...defaultValues,
      ...values,
      logo: _,
    };
    await requestApi('put', params);
    onOpen();
  };

  useEffect(() => {
    if (defaultValues.privacy_policy) {
      reset(defaultValuesSchema);
    }
  }, [defaultValues]);

  return (
    <FormBox>
      <PageTitle>Políticas de Privacidade</PageTitle>

      <AlertModal
        alertMsg={
          <Text textAlign="center" fontWeight="bold" fontSize="25px">
            {!error
              ? 'Políticas de privacidade editadas com sucesso!'
              : 'Erro ao editar as políticas de privacidade!'}
          </Text>
        }
        msgStatus={error ? 'error' : 'success'}
        closeOnOverlayClick={!!error}
        useSecondaryActions
        isOpenSecondary={isOpen}
        onCloseSecondary={onClose}
        ConfirmButton={
          <Button
            w="250px"
            boxShadow="0px 5px 10px #00000065"
            borderRadius="full"
            onClick={onClose}
          >
            Fechar
          </Button>
        }
      />

      <form noValidate onSubmit={handleSubmit(onSubmit, validationToast)}>
        <FormHeading>Dados Básicos</FormHeading>

        <Box flex={1}>
          <TextAreaInputForm
            name={privacyPolicy?.name}
            label={privacyPolicy?.label}
            placeholder={privacyPolicy?.placeholder}
            errors={errors}
            register={register}
          />
        </Box>

        <Flex mr="auto">
          <FormButton
            mt={4}
            w="100px"
            isLoading={isSubmitting}
            type="submit"
            textTransform="uppercase"
          >
            Salvar
          </FormButton>
        </Flex>
      </form>
    </FormBox>
  );
}
